import { Store } from "redux";
import { DefaultSettings } from "../../../../settings/settings-util";
import { AlmeState } from "../../../../wireup/AlmeState";
import { updateOverlayFormFocusState } from "../actions/actions";

export const updateOverlayFormFocus = (shouldFocus: boolean, store: Store<AlmeState> | null, settings: DefaultSettings): void => {
    const stateLocation = settings.stateLocations.History.shouldFocus;
    store?.dispatch(updateOverlayFormFocusState(shouldFocus, stateLocation));
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/utilities/type.ts